export default __webpack_public_path__ + "static/media/Path3521.d4986172.svg";